import { Auth, API } from 'aws-amplify';


class Api {
  static instance = Api.instance || new Api();

  _cancelled = false;
  _ignoreList = [];

  reset() {
    Api.instance._cancelled = false;
    Api.instance._ignoreList = [];
  }

  cancelAll() {
    Api.instance._cancelled = true;
  }

  cancelAllExcept(ignoreList = []) {
    Api.instance._cancelled = true;
    Api.instance._ignoreList = [...(ignoreList || [])];
  }

  throwIfCancelled(fnName) {
    const ignore = Api.instance._ignoreList.includes(fnName);
    if (!ignore && Api.instance._cancelled) {
      console.log('[throwIfCancelled] cancelling ', fnName);
      throw { cancelled: true };
    }
  }

  async process(url, myInit, type) {
   try{
    const tokens = await Auth.currentSession();
    const headers = {
      Authorization: tokens.idToken.jwtToken,
    };
    const result = await API[type]('AnalyticsAPI', url, {
      ...myInit,
      headers,
    });
    return result;
   }catch(err){
    console.error(err);
   }
  }

  async getData(url, myInit = {}) {
    const result = await this.process(url, myInit, 'get');
    return result;
  }
  async postData(url, myInit = {}) {
    this.throwIfCancelled('postData');
    const result = await this.process(url, myInit, 'post');
    this.throwIfCancelled('postData');
    return result;
  }
  async delData(url, myInit = {}) {
    this.throwIfCancelled('delData');
    const result = await this.process(url, myInit, 'del');
    this.throwIfCancelled('delData');
    return result;
  }
  async putData(url, myInit = {}) {
    this.throwIfCancelled('putData');
    const result = await this.process(url, myInit, 'put');
    this.throwIfCancelled('putData');
    return result;
  }
}

export default Api;
